import { HttpClient } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import {
    DefaultDataService,
    HttpUrlGenerator,
    Logger,
    QueryParams,
    Update,
} from 'ngrx-data';
import { Observable } from 'rxjs';
import { map, filter, tap } from 'rxjs/operators';

import { mapProperties, mapPropertiesObj } from '../general/generic.function';
import { I1FilenetServices } from '../i1-filenet-services.service';
import { Folder } from './folder.dto';
import { IAclID } from '../aclID.interface';

@Injectable({
    providedIn: 'root',
})
export class FolderDataService extends DefaultDataService<Folder> {
    constructor(
        http: HttpClient,
        httpUserGenerator: HttpUrlGenerator,
        @Optional() logger: Logger,
        private i1FilenetServices: I1FilenetServices
    ) {
        super('Folder', http, httpUserGenerator);
    }

    getWithQuery(queryParams: QueryParams): Observable<Folder[]> {
        const os = queryParams.objectStore as string;
        const complete = queryParams.complete as string;
        const folderIDs = queryParams.folderIds as string[];

        return this.i1FilenetServices
            .getFolders(os, folderIDs === null ? [] : folderIDs, complete)
            .pipe(
                map(folders => {
                    return folders.map(folder => mapProperties(folder));
                }),
                map(folders =>
                    folders
                        .map(v => (v.isRoot ? { ...v, objectStore: os } : v))
                        .map(v => {
                            if (v.audits) {
                                v.audits = v.audits.map(row =>
                                    mapProperties(row)
                                );
                            }
                            return v;
                        })
                )
            );
    }

    // requestSet = {};
    // getWithQuery(queryParams: QueryParams): Observable<Folder[]> {
    //     const os = queryParams.objectStore as string;
    //     const folderIDs = queryParams.folderIds as string[];
    //     const key = folderIDs.reduce((acc, row) => `${acc}${row}`, '');
    //     if (!this.requestSet[key]) {
    //         this.requestSet[key] = this.i1FilenetServices
    //             .getFolders(os, folderIDs === null ? [] : folderIDs)
    //             .pipe(
    //                 map(folders => {
    //                     return folders.map(folder => mapProperties(folder));
    //                 }),
    //                 tap(_ => delete this.requestSet[key])
    //             );
    //     }

    //     return this.requestSet[key];
    // }

    update(input: Update<Folder>): Observable<Folder> {
        console.log('Updating');
        const folder = ({ ...input.changes } as unknown) as Folder;
        const updateFolder = mapPropertiesObj({ ...folder }) as Folder;
        delete updateFolder.audits;

        const os = updateFolder.objectStore;

        delete updateFolder.objectStore; // Not accepted by backend
        return this.i1FilenetServices.updateFolder(os, updateFolder).pipe(
            filter(v => !!v),
            map(v => (mapProperties(v[0]) as unknown) as Folder),
            map(v => {
                if (v.audits) {
                    v.audits = v.audits.map(row => mapProperties(row));
                }
                return v;
            })
        );
    }
}
